import SvgIcon from '@mui/material/SvgIcon';

const TaskFlag = (props) => (
	<SvgIcon {...props} viewBox="0 0 20 20">
		<path d="M1 0v20H0V0h1Zm8.679 2.067.321.16c3.177 1.637 6.51 1.637 10 0l-3.954 6.768L20 13.236c-3.497 1.494-6.728 1.544-9.694.15l-.306-.15c-2.479-1.256-5.146-1.491-8-.704v-1.034l.118-.03c2.82-.697 5.498-.461 7.983.705l.63.308c2.21 1.039 4.582 1.195 7.152.454l.365-.111-3.44-3.691 2.943-5.041-.128.034c-2.663.634-5.258.355-7.744-.842l-.632-.315C7.109 1.945 4.914 1.733 2.62 2.33l-.345.095L2 2.505V1.464c2.65-.78 5.21-.579 7.679.603Z" />
	</SvgIcon>
);
export default TaskFlag;
